import type { DsComponentRenderProp } from "../components/component-render";
import { useDsFlashStore } from "../components/flash/DsFlashStore";

export class DsFlashNotifier {
  static info(content: string | DsComponentRenderProp, id = "ds-flash") {
    return useDsFlashStore().add({
      content: content,
      themeColor: "blue",
      id: id,
    });
  }

  static error(content: string | DsComponentRenderProp, id = "ds-flash") {
    return useDsFlashStore().add({
      content: content,
      themeColor: "red",
      id: id,
    });
  }

  static warning(content: string | DsComponentRenderProp, id = "ds-flash") {
    return useDsFlashStore().add({
      content: content,
      themeColor: "yellow",
      id: id,
    });
  }

  static success(content: string | DsComponentRenderProp, id = "ds-flash") {
    return useDsFlashStore().add({
      content: content,
      themeColor: "green",
      id: id,
    });
  }

  static hide(id = "ds-flash") {
    useDsFlashStore().remove(id);
  }
}
